import React from "react";
import data from "./data";
import {Carousel, Col, Space, Row, Skeleton, Divider} from "antd";
import {Testimonial} from "interfaces";
import useFetch from "hooks/fetch";

const Testimonials : React.FC = () => {

    const [isLoading, datasource] = useFetch("testimonial", "desc");

    return (
        <section id={"testimonial"} className={"main-testimonial"}>
            <div className={"public-container"}>
                <Row gutter={[50, 10]}>
                    <Col md={8} sm={24} xs={24}>
                        <div className={"section-heading"}>
                            <h2 className={"title"}>{data.testimonial.id.title}</h2>
                        </div>
                    </Col>
                    <Col md={16} sm={24} xs={24}>
                        <div className={"carousel-section"}>
                            <Carousel
                                autoplay={true}
                                dots={{className : "cr-dots"}}
                            >
                                {
                                    (isLoading ? new Array(5).fill(1, 0, 5) : datasource)
                                        .map((item : Testimonial, x) => (
                                            <div key={x} className={"section-quote"}>
                                                {
                                                    isLoading
                                                        ? <Skeleton active={true} title={false} paragraph={{rows : 3}} />
                                                        : <blockquote>
                                                            <p className={"says"}>{item.content}</p>
                                                        </blockquote>
                                                }
                                                <div className={"quote-source"}>
                                                    <Space align={"start"}>
                                                        <h3><strong>- {item.name}, </strong></h3>
                                                        {item.position}
                                                    </Space>
                                                </div>
                                            </div>
                                        ))
                                }
                            </Carousel>
                        </div>
                        <Divider style={{marginTop : 50}} />
                    </Col>
                </Row>
            </div>
        </section>
    )
}

export default React.memo(Testimonials);